import React from 'react';

import {
  Grid,
  Avatar,
  Typography,
  Divider,
  Button,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { formatRoute } from 'react-router-named-routes';

import * as constants from '../../../config/constants';
import classes from '../../../css/getCSS';
import * as routes from '../../../config/routes';


const activityListItem = (props) => {
  const avatarURL = constants.BASE_URL + props.activity.target_user.avatar;
  const profileLink = formatRoute(routes.VIEW_PROFILE, { uuid: props.activity.target_user.slug });

  let activityLink = null;
  let openText = null;

  if (props.content_type === 'shortlist') {
    activityLink = formatRoute(routes.MANAGE_ACTIVITY_ITEM, { type: 'shortlists', slug: props.activity.slug });
    openText = 'View Shortlist';
  }

  if (props.content_type === 'interest') {
    activityLink = formatRoute(routes.MANAGE_ACTIVITY_ITEM, { type: 'interests', slug: props.activity.slug });
    openText = 'View Interest';
  }

  if (props.content_type === 'request') {
    activityLink = formatRoute(routes.MANAGE_ACTIVITY_ITEM, { type: 'requests', slug: props.activity.slug });
    openText = 'View Request';
  }

  if (props.content_type === 'interestreply') {
    activityLink = formatRoute(routes.MANAGE_ACTIVITY_ITEM, { type: 'interests', slug: props.activity.slug });
    openText = 'View Interest';
  }

  if (props.content_type === 'requestreply') {
    activityLink = formatRoute(routes.MANAGE_ACTIVITY_ITEM, { type: 'requests', slug: props.activity.slug });
    openText = 'View Request';
  }

  if (props.content_type === 'recommendation') {
    activityLink = formatRoute(routes.MANAGE_ACTIVITY_ITEM, { type: 'recommendations', slug: props.activity.slug });
    openText = 'View Recommendation';
  }

  if (props.content_type === 'message') {
    activityLink = formatRoute(routes.ACTIVITIES, { type: 'messages' });
    openText = 'View All Messages';
  }

  let extraData = null;
  if (props.content_type === 'interest' && props.activity.message !== '') {
    extraData = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
          Message: {props.activity.message}
        </blockquote>
        <br />
      </React.Fragment>
    );
  }
  if (props.content_type === 'request') {
    extraData = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
          Requested: {props.activity.options}
        </blockquote>
        <br />
      </React.Fragment>
    );
  }

  if (props.content_type === 'interestreply' || props.content_type === 'requestreply') {
    const replies = {
      accept: 'ACCEPTED',
      reject: 'REJECTED',
    };
    extraData = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
          Reply: {replies[props.activity.reply]}
        </blockquote>
        <br />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Link className={classes.linkDeCSS} to={profileLink}>
        <Grid container spacing={8}>
          <Grid item md={3} sm={3} xs={4} className={classes.padding20} align="center">
            <Avatar className={classes.activityActionAvatar} alt={props.slug} src={avatarURL} />
          </Grid>
          <Grid item md={9} sm={9} xs={8} className={classes.padding20}>
            <Typography variant="title">{props.activity.target_user.first_name} {props.activity.target_user.last_name}</Typography>
            <Typography variant="body1">{props.activity.target_user.profile_id}</Typography>
            <Typography variant="body1">
              Last active: {props.activity.target_user.last_login ? props.activity.target_user.last_login : 'Never'}
            </Typography>
          </Grid>
        </Grid>
      </Link>
      {extraData}
      <Divider />
      <Grid container>
        <Grid item md={6} sm={6} xs={6} align="center" className={classes.padding10}>
          <Link className={classes.linkDeCSS} to={activityLink} target="_blank">
            <Button variant="flat" color="default" size="small">{openText}</Button>
          </Link>
        </Grid>
        <Grid item md={6} sm={6} xs={6} align="center" className={classes.padding10}>
          <Link className={classes.linkDeCSS} to={profileLink} target="_blank">
            <Button variant="flat" color="default" size="small">View Profile</Button>
          </Link>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default activityListItem;



// WEBPACK FOOTER //
// ./src/dashboard/components/activities/ActivityListItem.js